import React from "react";

// Step-0 scheduling UI: real slot picker when the expert has an availability
// calendar, manual date/time fallback otherwise.
export const SlotPicker = ({
  slotsData,
  selectedDate,
  selectedTime,
  onSelectDate,
  onSelectTime,
  minDateStr,
}) => {
  if (slotsData === null) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="w-6 h-6 border-2 border-[#0F172A] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!slotsData.has_availability) {
    return (
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-semibold text-[#0F172A] uppercase tracking-wider block mb-2">Date</label>
          <input
            type="date"
            value={selectedDate}
            min={minDateStr}
            onChange={(e) => onSelectDate(e.target.value)}
            className="w-full border border-[#E4E4E1] bg-white text-sm px-3 py-2.5 rounded-sm focus:outline-none focus:border-[#0F172A]"
            data-testid="booking-date-input"
          />
        </div>
        <div>
          <label className="text-xs font-semibold text-[#0F172A] uppercase tracking-wider block mb-2">Preferred Time</label>
          <input
            type="time"
            value={selectedTime}
            onChange={(e) => onSelectTime(e.target.value)}
            className="w-full border border-[#E4E4E1] bg-white text-sm px-3 py-2.5 rounded-sm focus:outline-none focus:border-[#0F172A]"
            data-testid="booking-time-input"
          />
        </div>
      </div>
    );
  }

  const dayTimes = slotsData.slots.find((s) => s.date === selectedDate)?.times || [];

  return (
    <div className="space-y-4">
      <div>
        <label className="text-xs font-semibold text-[#0F172A] uppercase tracking-wider block mb-2">Pick a date</label>
        {slotsData.slots.length === 0 ? (
          <p className="text-sm text-[#52525B] bg-[#F4F4F1] p-4 rounded-sm">
            No open slots in the next two weeks. Please check back later.
          </p>
        ) : (
          <div className="flex gap-2 overflow-x-auto pb-2" data-testid="slot-date-list">
            {slotsData.slots.map((s) => (
              <button
                key={s.date}
                onClick={() => onSelectDate(s.date)}
                className={`shrink-0 border rounded-sm px-3 py-2 text-xs font-medium transition-colors ${selectedDate === s.date ? "bg-[#0F172A] text-white border-[#0F172A]" : "bg-white text-[#0F172A] border-[#E4E4E1] hover:border-[#0F172A]"}`}
                data-testid={`slot-date-${s.date}`}
              >
                {s.day_label}
                <span className={`block text-[10px] mt-0.5 ${selectedDate === s.date ? "text-white/60" : "text-[#A1A1AA]"}`}>{s.times.length} slots</span>
              </button>
            ))}
          </div>
        )}
      </div>
      {selectedDate && (
        <div>
          <label className="text-xs font-semibold text-[#0F172A] uppercase tracking-wider block mb-2">
            Available times <span className="normal-case font-normal text-[#A1A1AA]">(IST · {slotsData.duration} mins)</span>
          </label>
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-2" data-testid="slot-time-list">
            {dayTimes.map((t) => (
              <button
                key={t}
                onClick={() => onSelectTime(t)}
                className={`border rounded-sm py-2 text-sm font-medium transition-colors ${selectedTime === t ? "bg-[#064E3B] text-white border-[#064E3B]" : "bg-white text-[#0F172A] border-[#E4E4E1] hover:border-[#0F172A]"}`}
                data-testid={`slot-time-${t}`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
